import { useField } from 'formik'
import { FieldSchema } from 'components/Wizards/Wizard/Form/Types'
import { Field as BaseField } from 'components/Wizards/MobileWizards/Field/Field'
import { SegmentedControl } from 'blaze-ui/SegmentedControl/SegmentedControl'
import { SegmentedItemWithDescription } from 'blaze-ui/SegmentedControl/SegmentedItemWithDescription'
import { Item } from '@react-stately/collections'
import { BlogPostLength } from 'components/Wizards/BlogPostWizard/Types'

interface LengthOption {
  label: string
  description: string
}

const BLOG_LENGTH_OPTIONS: Record<BlogPostLength, LengthOption> = {
  [BlogPostLength.Short]: {
    label: 'Short',
    description: '400-600 words',
  },
  [BlogPostLength.Medium]: {
    label: 'Medium',
    description: '600-1000 words',
  },
  [BlogPostLength.Long]: {
    label: 'Long',
    description: '1000+ words',
  },
}

interface BlogLengthFieldProps {
  blogLengthField: FieldSchema
}

export const BlogLengthField = ({ blogLengthField }: BlogLengthFieldProps) => {
  const [field, , { setValue }] = useField<BlogPostLength>('blog_length')
  const { meta } = blogLengthField.describe()

  return (
    <BaseField label={meta.label}>
      <SegmentedControl
        activeItem={field.value}
        onItemClick={(value) => setValue(value as BlogPostLength)}
        rounded
        variant="secondary"
        isFullWidth
        size="lg"
      >
        {Object.entries(BLOG_LENGTH_OPTIONS).map(([value, option]) => (
          <Item key={value} textValue={option.label}>
            <SegmentedItemWithDescription
              label={option.label}
              description={option.description}
              active={value === field.value}
            />
          </Item>
        ))}
      </SegmentedControl>
    </BaseField>
  )
}
